module.exports = __webpack_public_path__ + "img/menu-white.7c80b180.svg";